//工具请求模块
import request from '../utils/request'

//支付订单
export const paySpend = (data) => {
    return request({
        method: 'post',
        url: '/pay/pay-spend',
        data,
    })
}
// 支付二维码弹窗
export function payCustomer(pay_status) {
    return request({
        method: 'post',
        url: '/pay/check-pay-qr-code-popup',
        data: {pay_status},
    })
}
